import { createPostRequest } from '../../../helpers/request/request.js';
import { API_URLS } from '../../../configs/constants/urls.js';
import { appendXsrfToken, onError, onSuccess } from '../../../helpers/request/utils.js';
import { modifyUtagDataAfterLoginsAndRegistrations } from '../../../tracking/tools.js';
import TokenService from '../../../helpers/request/tokens.js';
export const login = async (postData) => {
    try {
        if ((await TokenService.getCsrfToken()) !== true) {
            return onError();
        }
        const requestOptions = appendXsrfToken({});
        const response = await createPostRequest(API_URLS.BFF.LOGIN, postData, requestOptions);
        await modifyUtagDataAfterLoginsAndRegistrations();
        if (response.data.success) {
            return onSuccess(response.data.additionalInfo);
        }
        if ([1, 2, 3].includes(response.data.causeOfFailure)) {
            return onError(401);
        }
        else
            return onError(response.status | 500);
    }
    catch (error) {
        return onError();
    }
};
//# sourceMappingURL=login.js.map